import { useState, useEffect } from 'react';
import Status from '../Constants/Status';

function useRequest(
  request,
  params,
  initleData,
  isDisabled = false,
  customDependencyArr = undefined,
  options = {}
) {
  const [result, setResult] = useState({
    data: initleData,
    status: Status.Empty,
    ErrorMessage: '',
    usedParams: undefined
  });

  useEffect(() => {
    if (!isDisabled) {
      sendRequest();
    }
  }, [...(customDependencyArr ?? params), isDisabled]);

  useEffect(() => {
    if (options.clearOnDisabled && isDisabled) {
      resetData();
    }
  }, [isDisabled, options.clearOnDisabled]);

  function resetData() {
    setResult({
      data: initleData,
      status: Status.Empty,
      ErrorMessage: '',
      usedParams: undefined
    });
  }

  function sendRequest() {
    setResult(prevResult => ({
      ...prevResult,
      data: initleData,
      status: Status.Pending,
      ErrorMessage: '',
      usedParams: undefined
    }));
    request(...params)
      .then(res => {
        setResult(prevResult => ({
          ...prevResult,
          status: Status.Fullfilled,
          data: res,
          usedParams: params
        }));
        options?.onSuccess && options.onSuccess(res);
      })
      .catch(err => {
        setResult(prevResult => ({
          ...prevResult,
          status: Status.Rejected,
          ErrorMessage: err,
          usedParams: undefined
        }));
      });
  }
  return {
    data: result.data,
    status: result.status,
    ErrorMessage: result.ErrorMessage,
    update: sendRequest,
    usedParams: result.usedParams,
    resetData
  };
}

export default useRequest;
